<template>
  <div>
    <!-- 其他内容 -->
    <code-runner></code-runner>
  </div>
</template>

<script>
import CodeRunner from "@/components/comtest.vue";

export default {
  components: {
    CodeRunner
  }
  // 其他配置项和方法
};
</script>



// WEBPACK FOOTER //
// src/views/home/course/index.vue